import { z } from "zod";

import { DbEnum } from "../../../../generated/prisma-enums";
import { DocumentMetadataSchema } from "../../../../schemas/Document";
import { storableText } from "../../../../shared/core/storable-text.schema";

/**
 * Core CRUD operations for documents
 * Includes: List, Get, Create, Update, Delete
 */

// ============================================================================
// LIST
// ============================================================================

export const DocumentListParamsSchema = z.object({
  parentId: z.string().nullable().optional(),
  type: z.nativeEnum(DbEnum.DocumentType).optional(),
  sourceType: z.nativeEnum(DbEnum.DocumentSourceType).optional(),
  status: z.nativeEnum(DbEnum.DocumentStatus).optional(),
  isFolder: z.boolean().optional(),
  search: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(1000).optional(), // Coerce from query string
  offset: z.coerce.number().int().min(0).optional(), // Coerce from query string
  collectionId: z.string().optional()
});

// ============================================================================
// GET
// ============================================================================

export const DocumentGetPathVarsSchema = z.object({
  id: z.string()
});

// ============================================================================
// CREATE
// ============================================================================

export const DocumentCreateBodySchema = z.object({
  name: z.string().trim().min(1).max(255),
  displayName: z.string().max(255).optional(),
  description: z.string().optional(),
  type: z.nativeEnum(DbEnum.DocumentType),
  sourceType: z.nativeEnum(DbEnum.DocumentSourceType),
  mimeType: z.string().optional(),
  parentId: z.string().optional(),
  isFolder: z.boolean().optional(),
  metadata: DocumentMetadataSchema.optional()
});

// ============================================================================
// UPDATE
// ============================================================================

export const DocumentUpdatePathVarsSchema = z.object({
  id: z.string()
});

export const DocumentUpdateBodySchema = z.object({
  name: storableText(z.string().trim().min(1).max(255)).optional(),
  displayName: storableText(z.string().max(255)).optional(),
  description: storableText(z.string()).optional(),
  tags: z.array(z.string()).optional(),
  syncEnabled: z.boolean().optional(),
  syncFrequency: z.string().optional()
});

// ============================================================================
// DELETE
// ============================================================================

export const DocumentDeletePathVarsSchema = z.object({
  id: z.string()
});
